import axios from "axios"
export const updateUserLocation = (token, locationData) => {
    return axios.post(process.env.REACT_APP_API_URL + '/setUserLocation', locationData,
        {
            headers: {
                'Authorization': `${token}`
            }
        });
}